/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { IRole, IRoleContainer } from '../../models/Roles/RolesContracts';
import { CustomList, CustomListItem } from '../../shared/CustomList';
import { GenerateAvatar } from '../../shared/GenerateAvatar';
import { GLOBAL_LABEL, GLOBAL_ROLE_TYPE } from './constants';
import { useStyles } from './styles';
import { useSelector } from "react-redux";
import { selectAppLocation } from '../../store/appLocation/appLocationSelector';
import { selectResourcePermissions } from "../../store/auth/authSelector";
import { checkResourcePermission } from "../../shared/CheckPermissions/CheckPermission";
import { resources, actions } from "../../shared/CheckPermissions/constants";
import { getFeatureFlag as useFeatureFlag } from "@jda/lui-portal-utilities";
import { HARNESS_FEATURE_FLAG } from "../../utility/constants";

const RoleList = ({ filteredRoles, selectedItem, handleListItemClick, handleListItemCheck }: IRoleContainer) => {
  const appLocation = useSelector(selectAppLocation);
  const resourcePermissions = useSelector(selectResourcePermissions);
  const isExportRolesEnabled = useFeatureFlag(HARNESS_FEATURE_FLAG.exportRoles);
  const isExportAllow = resourcePermissions &&
    resourcePermissions.resources &&
    checkResourcePermission(actions.EXPORT, resourcePermissions.resources[resources.REALM_ENTITIES]);
  const { classes } = useStyles();

  const withCheckbox = Boolean(isExportRolesEnabled && isExportAllow && !appLocation);

  return (
    <CustomList
      key={0}
      dense={false}
      disableGutters={false}
      data={filteredRoles}
      selectedItem={selectedItem}
      onClick={handleListItemClick}
      handleListItemCheck={handleListItemCheck}
      withCheckbox={withCheckbox}
      centeredItem={true}
      renderItem={(item: IRole) => (
        <Box className={classes.listItem}>
          <CustomListItem
            key={item.realmId}
            enablePriorityBar={false}
            showAvatarContent={false}
            ListPrimaryContent={
              <Box className={classes.content}>
                <Typography variant="body1">
                  <Box component="span">
                    {item.name}
                  </Box>
                </Typography>
                {item.type === GLOBAL_ROLE_TYPE && (
                  <Chip label={GLOBAL_LABEL} variant="outlined" size="small" className={classes.chip} />
                )}
              </Box>
            }
            {...(!withCheckbox ? {
              ListAvatarContent: (<GenerateAvatar id={item.id.toString()} name={item.name} priority={item.priority} />)
            } : {})}
            wrapText={true}
          />
        </Box>
      )}
    />
  );
};
export default RoleList;
